var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.111 3.45365C13.3515 2.58656 12.9329 1.47302 12.9333 0.320312H9.49993V14.0981C9.47345 14.8437 9.15867 15.5499 8.62189 16.068C8.08511 16.5862 7.3682 16.8758 6.62215 16.8759C5.04437 16.8759 3.73326 15.587 3.73326 13.987C3.73326 12.0759 5.57771 10.6425 7.47771 11.2314V7.72031C3.64437 7.2092 0.288818 10.187 0.288818 13.987C0.288818 17.687 3.35549 20.3203 6.61104 20.3203C10.0999 20.3203 12.9333 17.487 12.9333 13.987V6.99809C14.3255 7.99792 15.997 8.53436 17.711 8.53142V5.09809C17.711 5.09809 15.6222 5.19809 14.111 3.45365Z",
    fill: "#EB5B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.92311ed0df093d0123b7fec66f52458c.svg";
export { ForwardRef as ReactComponent };